export class WidgetError extends Error {
    rawError = {};

    constructor(name, message, rawError = {}) {
        super(message);
        this.name = name;
        this.rawError = rawError;
    }
}